import { useTheme } from '../../../redux/hooks/useTheme';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';


const NotFoundPage = () => {
  const { theme } = useTheme();
    const navigate=useNavigate();
  return (
    <div
      className={`flex flex-col items-center justify-center min-h-screen`}
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        fontSize: '15px',
      }}
    >
      <div className="text-center">
        <h2 className="text-6xl font-bold mb-4" style={{ color: theme.Darkone }}>
          404
        </h2>
        <h2 className="text-2xl font-semibold mb-2">
          Oops! Page Not Found
        </h2>
        <p className="text-lg mb-6" style={{ color: theme.color }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          className={`px-6 py-2 text-lg font-medium rounded-lg transition-all`}
          style={{
            backgroundColor: theme.buttonBackground,
            color: theme.buttonTextColor,
            border: theme.border,
          }}
          onClick={()=>navigate('/')}
        >
      Home
        </button>
      </div>
     
    </div>
  );
};

export default NotFoundPage;
